var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topCenter"},_vm._l((_vm.dataSource),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',[_c('p',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.value))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }